import { NoMatchPage } from "components/NoMatchPage";
import HistoryRouter from "pages/history";
import JobsRouter from "pages/jobs";
import LoginRouter from "pages/login";
import LogoutRouter from "pages/logout";
import PartnerRouter from "pages/partner";
import PlannerRouter from "pages/planner";
import { PrivateRoute } from "pages/PrivateRoute";
import StockRouter from "pages/stock";
import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { IndexPage } from "./IndexPage";
import { LoginRoute } from "./LoginRoute";
import { PartnerRoute } from "./PartnerRoute";
import { UserpilotHandler } from "./UserpilotHandler";

const AppRouter: FC = () => {
  return (
    <>
      <Routes>
        <Route index element={<IndexPage />} />
        <Route path="login/*" element={<LoginRouter />} />
        <Route path="logout/*" element={<LoginRoute component={LogoutRouter} />} />
        <Route path="history/*" element={<PrivateRoute component={HistoryRouter} />} />
        <Route path="jobs/*" element={<PrivateRoute component={JobsRouter} />} />
        <Route path="planner/*" element={<PrivateRoute component={PlannerRouter} />} />
        <Route path="stock/*" element={<PrivateRoute component={StockRouter} />} />
        <Route path="partner/*" element={<PartnerRoute component={PartnerRouter} />} />
        <Route path="*" element={<NoMatchPage />} />
      </Routes>
      <UserpilotHandler />
    </>
  );
};

export default AppRouter;
